var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.02725 6.51838H0.875L3.74491 9.38832L6.61506 6.51838H4.46282C4.46973 4.14417 6.39262 2.22103 8.76682 2.21388C9.46577 2.2272 10.1525 2.39885 10.7756 2.71624L11.8513 1.64049C10.9124 1.09719 9.85125 0.800754 8.76682 0.779297C5.60072 0.787925 3.03612 3.35228 3.02725 6.51838Z",
    fill: "#969BAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6483 5.88066C12.6413 8.25486 10.7185 10.178 8.34423 10.1851C7.64531 10.1719 6.95848 10.0002 6.33552 9.68275L5.25977 10.7585C6.19865 11.3018 7.25985 11.5983 8.34423 11.6198C11.5101 11.6106 14.0744 9.0465 14.0838 5.88066H16.2361L13.3662 3.01074L10.496 5.88066H12.6483Z",
    fill: "#969BAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.bbcae7544429eefac105fdeac866bda9.svg";
export { ForwardRef as ReactComponent };